<template>
  <div class="coupon">
    <CouponList v-if="coupon.length"
      :lang="lang"
      :list="coupon"
      :couponKey="couponKey"
      :locale="locale" />
    <div v-else class="noCoupons">
      <img src="@/assets/img/ico_voucher.svg" alt="">
      <p v-html="locale.no_coupons"></p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CouponList from '@/components/Coupon/CouponList.vue'

export default {
  name: 'Coupon',
  props: [
    'id',
    'lang',
    'locale',
    'isPublic',
    'roomKey'
  ],
  components: {
    CouponList
  },
  computed: {
    ...mapGetters({
      coupon: 'coupon/getCoupon'
    }),
    couponKey () {
      const hasOid = !!this.oid && this.oid !== 'undefined' && this.oid !== 'na'
      const key = this.roomKey ? `spaceid=${this.space}&k=${this.key}` : hasOid ? `oid=${this.oid}` : null
      return key
    }
  },
  async mounted () {
    await this.getKey()
    this.getCoupon()
    this.track()
  },
  data () {
    return {
      space: this.$store.state.authentication.space,
      key: this.$store.state.authentication.k,
      oid: this.$store.state.authentication.oid
    }
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: 'coupon'
      })
    },
    async getKey () {
      if (this.isPublic) {
        const res = await this.$store.dispatch('authentication/getOtaKey')
        this.key = res
      }
    },
    getCoupon () {
      if (this.couponKey) {
        this.$store.commit('loading', true)
        this.$store.dispatch('coupon/getCoupon').then((res) => {
          this.$store.commit('loading', false)
        })
      } else {
        alert(this.locale.invalid_key)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.room {
  font-size: 2.4em;
  text-align: center;
  font-weight: 700;
  color: $color-lgrey2;
  &.hasCoupon {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 0 0.5em;
    font-size: 1.4em;
    color: $color-white;
    background-color: rgba($color-primary, 0.8);
    box-shadow: 0 0 5px rgba(0,0,0,0.3);
  }
}
</style>
